import { render } from "./MoveMeteringSystemForm.vue?vue&type=template&id=4f94670a&scoped=true"
import script from "./MoveMeteringSystemForm.vue?vue&type=script&lang=js"
export * from "./MoveMeteringSystemForm.vue?vue&type=script&lang=js"

import "./MoveMeteringSystemForm.vue?vue&type=style&index=0&id=4f94670a&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src2914688552/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f94670a"]])

export default __exports__